import React from 'react';
import './App.css';
import CSVViewer from './CSVViewer';

function App() {
  return (
    <div className="App">
      <CSVViewer />
    </div>
  );
}

export default App;